import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    getPatientDetailsVisits,
    getPtPastVitals,
    isAssessmentSummaryFilled,
} from '../../../../store/selectors/prescriptionPad';
import { PAST_VISIT_VITALS } from '../../../../pages/prescriptionPad/magicBox/magicBoxTableElements';
import PatientOverviewLabVitalsComponent from '../../LabVitalsHistoricalTable';
import Vitals from './Vitals';
import AssessmentSummaryPPRightPanel from '../../../../pages/prescriptionPad/AssessmentSummaryRightPanel';
import PatientOverViewBottomActionStrip from './padV2/PatientOverviewBottomActionStrip';
import { PastVisitTableComponent, Visits } from './PastVisits';
import { onCopy } from '../../../common/PastVisitUtils';

export const PATIENT_OVERVIEW_CONTAINER_ID = 'PATIENT_OVERVIEW_CONTAINER_ID';

const PPPatientOverview: React.FC<{ patientId: string }> = ({ patientId }) => {
    const isAsFilled = useSelector(isAssessmentSummaryFilled);
    const dispatch = useDispatch();

    const onCopyElement = (visit: Visits, allSections: string[]) => {
        onCopy('PX', visit, allSections, dispatch);
    };

    const visits = useSelector(getPatientDetailsVisits);
    const data = useSelector(getPtPastVitals) || {};
    const ptPastVitals = Object.keys(data).map((id) => ({
        id,
        ...data[id],
    }));

    return (
        <Fragment>
            <div
                id={PATIENT_OVERVIEW_CONTAINER_ID}
                className="col-span-11 relative overflow-auto p-16 z-0"
            >
                <div className="bg-white rounded-8">
                    {isAsFilled ? <AssessmentSummaryPPRightPanel showBottomPanel={false} /> : null}
                </div>
                <PastVisitTableComponent isWrapper={true} onCopy={onCopyElement} visits={visits} />
                <div className="h-auto lg:max-h-4/5 lg:min-h-4/5 lg:h-full lg:flex my-16">
                    <div className="h-full w-full min-w-60p">
                        <div className="h-full overflow-x-auto overflow-y-hidden relative  h-full lg:mr-16">
                            <div className="flex flex-col relative h-full rounded-8 col-span-12 bg-white overflow-auto">
                                <PatientOverviewLabVitalsComponent
                                    patientId={patientId}
                                    ptPastVitals={ptPastVitals}
                                    dispatch={dispatch}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="h-full my-16 lg:my-0 overflow-auto min-w-40p">
                        <div
                            className="overflow-auto h-full rounded-8  w-full"
                            id={PAST_VISIT_VITALS}
                        >
                            <Vitals visits={visits} />
                        </div>
                    </div>
                </div>
                <div style={{ height: '256px' }}></div>
            </div>
            <PatientOverViewBottomActionStrip />
        </Fragment>
    );
};

export default PPPatientOverview;
